import { Logger } from '../utils/logger';
import { postReq } from './api';

interface EventPayload {
  event_type: string;
  resource_type: string;
  resource_id: string | number;
  application: 'web';
}

interface OperationEventPayload {
  event_type: string;
  resource_type: string;
  resource_uuid: string;
  application: 'web';
}

const recordClearanceLogsCsvDownload = (accessToken: string, locationId: number) => {
  _recordEvent(accessToken, {
    event_type: 'clearance_log_download',
    resource_type: 'Location',
    resource_id: locationId,
    application: 'web'
  });
};

const recordVerificationsCsvDownload = (accessToken: string, agencyId: number | string) => {
  _recordEvent(accessToken, {
    event_type: 'verification_download',
    resource_type: 'Agency',
    resource_id: agencyId,
    application: 'web'
  });
};

const recordOperationActivityCsvDownload = (accessToken: string, operationId: string) => {
  _recordOperationEvent({
    accessToken,
    operationId,
    event: {
      event_type: 'operation_activity_download',
      resource_type: 'Operation',
      resource_uuid: operationId,
      application: 'web'
    }})
};

const _recordEvent = async (accessToken: string, event: EventPayload): Promise<void> => {
  const resp = await postReq<any>('/events', accessToken, event);
  if (resp.errors) {
    Logger.error('Error recording event', { event, resp });
  }
};

const _recordOperationEvent = async ({ accessToken, operationId, event }: {
  accessToken: string,
  operationId: string,
  event: OperationEventPayload
}) => {
  const response = await postReq(
    `/operations/${operationId}/events`,
    accessToken,
    { event }
  );

  if (response.errors) {
    Logger.error('Error recording event', { event, response });
  }
};

export const EventService = {
  recordClearanceLogsCsvDownload,
  recordVerificationsCsvDownload,
  recordOperationActivityCsvDownload
};
